module.exports = __webpack_public_path__ + "static/img/io.5af50607.svg";